import nav from './nav';
import config from './config';
import input from './input';
export default {
    nav,
    config,
    input
};
